/**
 * Profile links a resume text names but never spells out.
 *
 * Uploaded PDFs need no help: the server reads link targets straight out of
 * the file (server/pdf-links.ts). Plain text is the case nothing can recover —
 * a resume pasted in, or one loaded from an earlier match check, keeps the word
 * "LinkedIn" and nothing else. Only then is it worth asking the user.
 */

/** Profiles worth a warning. Anything rarer is not worth the false positives. */
const PROFILES = [
  {
    label: "LinkedIn",
    mention: /\blinkedin\b/i,
    url: /linkedin\.com\/[a-z]{2,4}\/[\w%-]+/i,
  },
  {
    label: "GitHub",
    mention: /\bgit\s?hub\b/i,
    url: /github\.(?:com|io)\/[\w.-]+/i,
  },
  {
    label: "Portfolio",
    mention: /\bportfolio\b/i,
    url: /https?:\/\/|\bwww\.[\w-]+\.\w{2,}|\b[\w-]+\.(?:com|dev|io|me|net|org|xyz|site|app)\b/i,
  },
] as const;

/** Names a profile the text talks about but never gives a usable URL for. */
export function labelsMissingUrls(text: string): string[] {
  if (!text.trim()) return [];
  return PROFILES.filter((p) => p.mention.test(text) && !p.url.test(text)).map((p) => p.label);
}
